export default function (v: string | null): string {
  if (!v) return "";
  return v.split("-").reverse().join("-");
}
